import React from 'react';
import { Button, Link } from '@paypalcorp/pp-react';
import getContent from '../lib/dictionaryFetcher';
import PropTypes from 'prop-types';
import { extend, get } from 'lodash';
import RestartQuiz from './RestartQuiz';
import { MISC } from '../lib/constants';
class ResultsZeroStateView extends React.Component {
  zeroStateIm = () => {
    let { location, fptiHelper } = this.props;
    const fptiObject = {
      page: 'main:businessweb:mep:dashboard:main:quiz:zero_setup_stage',
      entry_point: get(location, 'search', '').includes('appcenter=true')
    };
    fptiHelper.fptiImpression(fptiObject);
  };
  handleClicks = e => {
    const { location, fptiHelper } = this.props;
    let options = {
      page: 'main:businessweb:mep:dashboard:main:quiz:zero_setup_stage',
      entry_point: get(location, 'search', '').includes('appcenter=true')
    };
    if (e.target.classList.contains('retake-guided-setup')) {
      extend(options, { link: 'answer_questions_again' });
      fptiHelper.fptiClick(options);
      setTimeout(() => {
        window.location = '/merchantapps/setup-recommendations';
      }, 500);
    } else if (e.target.classList.contains('app-center-link')) {
      extend(options, { link: 'app_center' });
      fptiHelper.fptiClick(options);
    } else if (e.target.classList.contains('results-appcenter-button')) {
      extend(options, { link: 'go_to_app_center' });
      fptiHelper.fptiClick(options);
    }
  };
  render() {
    const {
      shouldShowZeroState,
      maxLength,
      submitResults,
      location,
      fptiHelper
    } = this.props;
    let headingThree = getContent('quiz', 'results.zeroState.heading3', '', {
      params: { appcenter: '/merchantapps/appcenter' }
    });
    if (shouldShowZeroState === maxLength) {
      this.zeroStateIm();
      return (
        <div
          className="results-zerostate"
          role="presentation"
          onClick={this.handleClicks}
        >
          <img
            className="results-zerostate-icon"
            src={`${MISC.PAYPAL_IMAGES_LOC}/quiz/error.svg`}
            alt=""
            role="presentation"
          />
          <p className="results-zerostate-heading1">
            {getContent('quiz', 'results.zeroState.heading1')}
          </p>
          <p
            className="results-zerostate-heading2"
            dangerouslySetInnerHTML={{
              __html: getContent('quiz', 'results.zeroState.heading2')
            }}
          />
          <p
            className="results-zerostate-heading3"
            dangerouslySetInnerHTML={{ __html: headingThree }}
          />
          <Button
            href="/merchantapps/appcenter"
            target="_blank"
            as={Link}
            className="results-appcenter-button"
            style={{ marginTop: '34px' }}
          >
            {getContent('quiz', 'results.zeroState.buttonText')}
          </Button>
        </div>
      );
    }
    return (
      <div className="results-submit">
        <Button
          className="results-zero-submit"
          onClick={() => {
            submitResults(['userProducts', 'developerProducts']);
          }}
        >
          {getContent('quiz', 'results.start')}
        </Button>
        <RestartQuiz
          marginTop="13px"
          location={location}
          fptiHelper={fptiHelper}
        />
      </div>
    );
  }
}
ResultsZeroStateView.propTypes = {
  shouldShowZeroState: PropTypes.number,
  maxLength: PropTypes.number,
  submitResults: PropTypes.func,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default ResultsZeroStateView;
